import React from "react";
import "../styles/global.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

import {NavLink, Link} from "react-router-dom";
import { M300Logo } from "./Images";

export default function Navigation() {
  return (
    <nav id="sidebar">
      <Link
        to="/"
        title="Visit the home page"
        className="nav-items nav-link logo-link"
        key='nav-logo'
      >
        <img
          alt="DRE Atlas Logo"
          src={M300Logo}
          className="img-fluid nav-logo-sidebar"
        />
      </Link>
      <div className="nav-icons">
        <NavLink
          to="/"
          title="Visit the home page"
          className="nav-items nav-link"
          key='nav-home'
        >
          <FontAwesomeIcon
            icon={faHome}
            className="other-icons"
          />
        </NavLink>
        <NavLink
          to="/countries"
          className="nav-items nav-link"
          key='nav-countries'
          title="Explore country platforms"
        >
          <img src="/~/../static/img/Globe.svg" className="other-icons" />
        </NavLink>
        <NavLink
          to="/about"
          className="nav-items nav-link"
          key='nav-about'
          title="About"
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            className="other-icons"
          />
        </NavLink>
      </div>
    </nav>
  );
}
